import { createContext, useReducer } from "react";
import { createRenderer } from "react-dom/test-utils";
import githubReducer from "./GithubReducer";


const GithubContext = createContext()

const GITHUB_URL = "https://api.github.com"

export const GithubProvider = ({children}) => {
   const intialState = {
    users: [],
    user: {},
    repos: [],
    loading: false,
   }

   const [state, dispatch] = useReducer(githubReducer, intialState)

    return (
        <GithubContext.Provider value={{
            ...state,
            dispatch,
        
        }}>
            {children}
        </GithubContext.Provider>
    )


}


export default GithubContext